import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

class RadarChart extends Component {

    constructor(props) {
        super(props);

        this.state = {
            options: {
                labels: ['Appealing Visual Design', 'Comm. Info. Structure', 'Visual Branding', 'Mastery', 'Outcome Satisfaction', 'Emotional Attachment', 'Task Effectiveness', 'Task Efficiency', 'Stability & Performance'],
                chart: {
                    width: '100%',
                    toolbar: {
                        show: false,
                    },
                },
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: undefined,
                    formatter: function (val, opts) {
                        return val
                    },
                    textAnchor: 'middle',
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        fontSize: '16px',
                        fontFamily: 'fira mono, Arial, sans-serif',
                        colors: ['#F1478A', '#FF5353', '#FF8B36', '#FFD271', '#7AF4A9', '#5BFBFF', '#EE4BF8', '#7667FA', '#37ABFF']
                    },
                },
                plotOptions: {
                    radar: {
                        size: 150,
                        polygons: {
                            strokeColors: 'transparent',
                            connectorColors: '#535353',
                            fill: {
                                colors: ['#2F2F2F', '#000']
                            }
                        }
                    }
                },
                fill: {
                    opacity: 0.5,
                    colors: ["#32B0EF"],
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ["#32B0EF"],
                },
                title: {
                    text: undefined,
                },
                markers: {
                    size: 5.5,
                    colors: ['#fff'],
                    strokeColor: '#32B0EF',
                    strokeWidth: 2,
                },
                tooltip: {
                    theme: "dark",
                    y: {
                        formatter: function (val) {
                            return val.toFixed(2);
                        }
                    }
                },
                yaxis: {
                    tickAmount: 7,
                    max: 7,
                    labels: {
                        show: true,
                        style: {
                            color: "#fff",
                            fontSize: '14px',
                            fontFamily: 'fira sans, sans-serif',
                        },
                        formatter: function (val, i) {
                            if (i % 2 === 0) {
                                return val
                            } else {
                                return ''
                            }
                        }
                    }
                }
            },
        }
    }

    // Group answers, array in array, where each index corresponds to a question.
    // Then average the score of each question.
    getTransformedData() {
        let transformedData = {};
        let outputData = [];
        const limitedData = this.props.data.slice(-10);
        if (limitedData.length > 0) {
            limitedData.map((dataPoint, i) => {
                return dataPoint.answers.map((data, j) => {
                    if (typeof transformedData[j] === "object") {
                        transformedData[j].push(data);
                    } else {
                        transformedData[j] = [];
                        transformedData[j].push(data);
                    }
                });
            });
            Object.keys(transformedData).forEach((key) => {
                let sum = transformedData[key].reduce((acc, curr) => acc + curr);
                let avg = sum / transformedData[key].length;
                outputData.push(avg);
            });
            return this.averageEvery(outputData, 3);
        }
    }

    // Returns new arary with average for every three (in this case) questions.
    averageEvery(arr, n) {
        if (!arr || !n) {
            return false;
        }
        let groups = [];
        while (arr.length) {
            groups.push(arr.splice(0, n));
        }

        return groups.map(group => (
            group.reduce((a, b) => a + b) / group.length
        ));
    }

    render() {
        return (
            <div id="chart">
                <ReactApexChart options={this.state.options} series={[{ name: 'Total', data: this.getTransformedData() }]} type="radar" height="400" />
            </div>
        );
    }
}

export default RadarChart;